module.exports = __webpack_public_path__ + "0502d3b7428bc1ad4c7c265a9fdd96e9.pdf";